
<template>
  <div>
    <van-nav-bar
      title="选择座位"
      fixed
      placeholder
      left-text="返回"
      right-text="首页"
      left-arrow
      @click-left="goBack"
      @click-right="goHome"
    />
    <div class="h-8 half_circle title-bg"></div>
    <div
      class="
        mx-2
        -mt-8
        p-1.5
        filter
        drop-shadow-lg
        rounded-sm
        bg-white
        grid grid-rows-2 grid-flow-col
      "
    >
      <div class="flex justify-between">
        <span class="middle-text font-extrabold">{{ location }}</span
        ><span class="middle-text text-gray-400">空余{{ availableSeats }}</span>
      </div>
      <div @click="showMap" class="middle-text mt-0.5 text-gray-400">
        座位示意图&nbsp;&gt;
      </div>
    </div>
    <div class="mx-2 mt-1 p-1 bg-white rounded-sm">
      <div class="overflow-x-auto flex justify-evenly space-x-1">
        <van-button
          round
          plain
          v-for="(sday, idx) in days"
          :key="sday"
          :class="{ selected: sday === selectedDay }"
          @click="selectDay(sday)"
          ><span class="text-[10px] whitespace-nowrap"
            >{{ idx == 0 ? "今天" : "明天" }}({{ sday }})</span
          ></van-button
        >
      </div>
      <div
        class="overflow-x-auto flex justify-center mt-1 space-x-px"
        v-if="times.length > 0"
      >
        <van-button
          round
          plain
          v-for="time in times"
          :key="time.id"
          :disabled="!time.isValid"
          :class="{ selected: time.id === selectedTime.id }"
          class="whitespace-nowrap"
          @click="selectTime(time)"
          >{{ time.startTime }}-{{ time.endTime }}</van-button
        >
      </div>
      <div class="mt-1 rounded-md">
        <van-empty
          v-if="times.length == 0 || seats.length == 0"
          description="无可用预约时段"
        />
        <van-tabs v-else type="card" color="#49cfd4">
          <van-tab title="列表模式">
            <div>
              <div class="flex justify-between middle-text mt-1">
                <span class="text-gray-400">选择座位号</span
                ><span class="font-semibold">{{ selectedSeat.name }}</span>
              </div>
              <div
                ref="seatmap"
                class="grid grid-cols-4 place-content-start overflow-y-auto"
              >
                <div
                  class="
                    border border-blue-300
                    m-px
                    p-px
                    rounded-sm
                    text-center
                    small-text
                  "
                  :class="{ selected: seat.id === selectedSeat.id }"
                  @click="selectSeat(seat)"
                  v-for="seat in seats"
                  :key="seat.id"
                >
                  {{ seat.name }}
                </div>
                <van-divider class="col-span-4">到底了</van-divider>
              </div>
            </div>
          </van-tab>
          <van-tab title="地图模式">
            <div>
              <div class="flex justify-between middle-text mt-1">
                <span class="text-gray-400">选择座位号</span
                ><span class="font-semibold">{{ selectedSeat.name }}</span>
              </div>
              <div class="w-full relative">
                <div ref="zoommap">
                  <img :src="`/seatmap/${school}/${area}/seat-free.jpg`" />
                  <div
                    v-for="seat in allSeats"
                    :key="seat.id"
                    :style="calcSeatLocation(seat)"
                    class="absolute"
                    :class="{
                      'rounded-sm box-content border border-red-400':
                        seat.id === selectedSeat.id,
                    }"
                    @click="selectSeat(seat, $event)"
                  />
                </div>
              </div>
              <van-notice-bar
                left-icon="volume-o"
                wrapable
                :scrollable="false"
                text="可用双指放大或拖动"
              />
            </div>
          </van-tab>
        </van-tabs>
      </div>
    </div>
    <van-row class="fixed left-0 bottom-0 w-full bg-white small-text">
      <van-col span="6">
        <div class="text-center" @click="goBack">
          <van-icon name="exchange" />
          <span class="inline-block">切换阅览室</span>
        </div>
      </van-col>
      <van-col span="18">
        <van-button block size="large" @click="bookingNow" :color="disableBook?'':'#49cfd4'" type="default"
          >{{disableBook?`暂停预约(${current.hours}:${current.minutes}:${current.seconds})`:"马上预约"}}</van-button
        >
      </van-col>
    </van-row>
  </div>
  <van-image-preview
    v-model:show="mapShown"
    min-zoom="1"
    :images="[`/figure/${school}/${area}/seat-free.jpg`]"
  >
  </van-image-preview>
</template>

<script>
import { toRefs, reactive, ref, onMounted, watch} from "vue";
import qs from "qs";
import { useRouter } from "vue-router";
import { myStorage } from "@/utils/util";
import { Dialog, Toast } from "vant";
import { useCountDown} from '@vant/use';
import _ from "lodash";
import dayjs from "dayjs";
import {
  getOpenDays,
  getSeats,
  getAreas,
  bookSeat,
  getServerTime,
  getOpenTime,
} from "@/service/home";
import Panzoom from "@panzoom/panzoom";
import Cookies from "js-cookie";
export default {
  name: "bookseat",
  components: {},
  setup() {
    const user = JSON.parse(Cookies.get("user"));
    const school = JSON.parse(Cookies.get("school")).school;
    const router = useRouter();
    const seatmap = ref(null);
    const zoommap = ref(null);
    const area = ref(0);
    const startTime = ref("");
    const state = reactive({
      allSeats: [],
      seats: [],
      days: [],
      times: [],
      rawDays: [],
      selectedDay: "",
      selectedTime: "",
      selectedSeat: {},
      location: "",
      availableSeats: 0,
      mapShown: false,
      ratio: 1.0,
      school: school,
      openTime: {},
      current:{},
      disableBook:true,
    });
    const areaId = myStorage.get("area").id;
    area.value = areaId;
    const bgPrefix = "/seatmap/" + school + "/" + areaId;
    const idleBackground = bgPrefix + "/seat-free.jpg";
    const bookBackground = bgPrefix + "/seat-book.jpg";
    const closeBackground = bgPrefix + "/seat-close.jpg";
    const useBackground = bgPrefix + "/seat-use.jpg";
    const leaveBackground = bgPrefix + "/seat-leave.jpg";
    onMounted(() => {
      init();
    });

    watch(
      () => state.selectedDay,
      async (newValue) => {
        try {
          state.times = _.map(
            _.filter(state.rawDays, { day: newValue }),
            (day) => {
              return {
                id: day.id,
                startTime: day.startTime.date.slice(11, 16),
                endTime: day.endTime.date.slice(11, 16),
                isValid: dayjs().isBefore(
                  dayjs([day.day, day.endTime.date.slice(11)].join(" "))
                ),
              };
            }
          );
          if (state.times.length > 0) {
            let validTimes = _.filter(state.times, { isValid: true });
            state.selectedTime = validTimes.length > 0 ? validTimes[0] : "";
          }
        } catch (err) {
          state.times = [];
        }
      }
    );
    watch(
      () => state.selectedTime,
      async (newValue) => {
        try {
          if (
            dayjs().isAfter(dayjs(state.selectedDay + " " + newValue.startTime))
          ) {
            startTime.value = dayjs().format("HH:mm");
          } else {
            startTime.value = newValue.startTime;
          }
          const {
            data: { list: seats },
          } = await getSeats({
            area: areaId,
            segment: newValue.id,
            day: state.selectedDay,
            startTime: startTime.value,
            endTime: newValue.endTime,
          });
          state.allSeats = _.orderBy(seats, ['no'],['asc']);
          state.seats = _.filter(state.allSeats, { status: 1 });
          state.selectedSeat = state.seats[0] || {};
          state.availableSeats = state.seats.length;
        } catch (err) {
          state.seats = [];
        }
      }
    );
    const init = async () => {
      try {
        state.openTime = await getOpenTime();
        const {
          data: { list },
        } = await getOpenDays(areaId);
        state.rawDays = list;
        state.days = _.uniq(_.map(list, "day"));
        state.selectedDay = myStorage.get("day") || state.days[0];
        const {
          data: { list: area },
        } = await getAreas({ id: areaId });
        state.location = area.areaInfo.nameMerge;
        const space = _.head(_.filter(area.seatinfo, { id: areaId }));
        state.availableSeats = space.TotalCount - space.UnavailableSpace;
      } catch (error) {
        Toast({
          message: "系统繁忙，请稍后再试",
          forbidClick: true,
          overlay: true,
        });
      }
      await showCountdown();
      // 设置座位图缩放比例，根据渲染的座位列表宽度与背景图原始宽度的比
      const seatInterval = setInterval(() => {
        if (seatmap.value) {
          let style = window.getComputedStyle(seatmap.value, null);
          seatmap.value.style.height = window.innerHeight * 0.375 + "px";
          state.ratio = (
            parseFloat(style.width.replace("px", "")) / 1366
          ).toFixed(3);
          clearInterval(seatInterval);
        }
      }, 50);
      const mapInterval = setInterval(() => {
        if (zoommap.value) {
          Panzoom(zoommap.value, { minScale: 1, maxScale: 5, step: 0.5 });
          clearInterval(mapInterval);
        }
      }, 50);
    };
    const showCountdown = async () => {
      const serverTime = await getServerTime();
      let nowUnix = dayjs.unix(serverTime / 29 - 509);
      let todayStartTime = new Date();
      todayStartTime.setHours(parseInt(state.openTime.beginTime.substr(0,2)));
      todayStartTime.setMinutes(parseInt(state.openTime.beginTime.substr(3,2)));
      todayStartTime.setSeconds(0);
      let todayEndTime = new Date();
      todayEndTime.setHours(parseInt(state.openTime.endTime.substr(0,2)));
      todayEndTime.setMinutes(parseInt(state.openTime.endTime.substr(3,2)));
      todayEndTime.setSeconds(0);
      let startTime = dayjs(todayStartTime);
      let endTime = dayjs(todayEndTime);
      if (nowUnix.isAfter(endTime)) {
        startTime = startTime.add('24', 'h');
      }
      const countDown = useCountDown({
        time: startTime.diff(nowUnix),
        onFinish: function() {state.disableBook = false;}
      })
      countDown.start();
      state.current = countDown.current;
    };
    const book = async () => {
      if (state.disableBook) return false;
      try {
        const bookResult = await bookSeat(
          state.selectedSeat.id,
          qs.stringify({
            access_token: user.access_token,
            userid: user.userid,
            segment: state.selectedTime.id,
            type: 1,
            operateChannel: 3,
          })
        );
        if (!bookResult || bookResult.status <= 0 || bookResult.data == null) {
          throw new Error(bookResult.msg);
        }
        let violation = bookResult.data.list.renegeinfo
          ? bookResult.data.list.renegeinfo.count
          : null;
        violation = violation ? "提醒：" + violation : "";
        Dialog.alert({
          title: "预约成功",
          allowHtml: true,
          messageAlign: "left",
          message:
            "区域：" +
            state.location +
            ":" +
            bookResult.data.list.spaceInfo.name +
            "\n" +
            "时间：" +
            state.selectedDay +
            " " +
            startTime.value +
            "-" +
            state.selectedTime.endTime +
            "\n" +
            '<p class="text-red-800">' +
            violation +
            "</p>",
        }).then(() => {
          router.push("/index");
        });
      } catch (err) {
        if ((err.message.indexOf("undefined")>-1) || (err.message.indexOf("Error")>-1)) {
          err.message = "系统繁忙,请稍后再试";
        }
        Dialog.alert({
          title: "提示",
          messageAlign: "left",
          message: err.message,
        }).then(async () => {
          const {
            data: { list: seats },
          } = await getSeats({
            area: areaId,
            segment: state.selectedTime.id,
            day: state.selectedDay,
            startTime: startTime.value,
            endTime: state.selectedTime.endTime,
          });
          state.allSeats = seats;
          state.seats = _.filter(seats, { status: 1 });
          state.selectedSeat = state.seats[0] || {};
          state.availableSeats = state.seats.length;
        });
      }
    };
    const bookingNow = () => {
      const throttledBook = _.throttle(book, 15 * 1000, { trailing: false });
      throttledBook();
    };
    const goBack = () => router.go(-1);
    const goHome = () => router.push("/index");
    const selectDay = (day) => {
      state.selectedDay = day;
    };
    const selectTime = (time) => {
      state.selectedTime = time;
    };
    const selectSeat = (seat, event) => {
      if (seat.status != 1) {
        return;
      }
      if (event) {
        let seatDom = event.target;
        seatDom.style.zIndex = "100";
      }
      state.selectedSeat = seat;
    };
    const showMap = () => {
      state.mapShown = !state.mapShown;
    };

    const calcSeatLocation = (seat) => {
      let backgroundImg = null;
      if (seat.status == 1) {
        backgroundImg = idleBackground;
      } else if (seat.status == 7) {
        backgroundImg = leaveBackground;
      } else if ([2, 10, 11].includes(seat.status)) {
        backgroundImg = bookBackground;
      } else if ([6, 8, 9].includes(seat.status)) {
        backgroundImg = useBackground;
      } else if ([3, 4, 5].includes(seat.status)) {
        backgroundImg = closeBackground;
      }
      return {
        left: Math.round(((seat.point_x * 1366) / 100) * state.ratio) + "px",
        top: Math.round(((seat.point_y * 768) / 100) * state.ratio) + "px",
        width: Math.round(((seat.width * 1366) / 100) * state.ratio) + "px",
        height: Math.round(((seat.height * 768) / 100) * state.ratio) + "px",
        "background-image": "url(" + backgroundImg + ")",
        "background-repeat": "no-repeat",
        "background-position":
          "-" +
          Math.round(((seat.point_x * 1366) / 100) * state.ratio) +
          "px -" +
          Math.round(((seat.point_y * 768) / 100) * state.ratio) +
          "px",
        "background-size": Math.round(1366 * state.ratio) + "px",
      };
    };

    return {
      goBack,
      goHome,
      selectDay,
      selectTime,
      selectSeat,
      showMap,
      bookingNow,
      calcSeatLocation,
      seatmap,
      zoommap,
      area,
      startTime,
      ...toRefs(state),
    };
  },
};
</script>

<style lang="less" scoped>
@import "../common/style/base";
.selected {
  background-color: #49cfd4;
  color: white;
  z-index: 1000;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.block {
  width: 120px;
  height: 120px;
  background-color: #fff;
}
</style>
